import React, {useState, useEffect} from 'react';
import { DataTableComp } from "../Common/DataTable";
import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { AddUser } from "./Modal/AddUser";
import { UploadExcel } from "./Modal/UploadExcel";
import Switch from '@mui/material/Switch';
import LoginIcon from '@mui/icons-material/Login';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

export default function User() {
    const authUser = localStorage.getItem('FF-authUser');
    const user = JSON.parse(authUser);
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [show, setShow] = useState(false);
    const [editId, setEditId] = useState(0);
    const [popupType, setPopupType] = useState('Add');

    
    const [showexcelform, setShowexcelform] = useState(false);
    const handleCloseExcel = () => setShowexcelform(false);
    
    useEffect(() => {
        getList();
    }, [])

    const getList = async() => {
        await axios.get(`/api/users?role=Admin&parentId=${user.id}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setUsers(result.data)
            }
        })
    }
    
    const handleAdd = () => {
        setEditId(0);
        setPopupType('Add');
        setShow(true);
    }
    const handleEdit = (id) => {
        setEditId(id);
        setPopupType('Edit');
        setShow(true);
    }
    
    const handleUpload = () => {
        setEditId(0);
        setPopupType('UploadExcel');
        setShowexcelform(true);
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.delete(`/api/users/delete?id=${id}`).then((res) =>{
                    if(res.data.success){                             
                        Swal.fire('Deleted!', '', 'success')
                        getList();
                    } 
                }).catch((error) => {
                    console.log(error);                     
                    Swal.fire(error.message, '', 'info')           
                });
            } else if (result.isDenied) {
              Swal.fire('Cancelled!', '', 'info')
            }
        }) 
    }

    const handleStatus = (e, id) => { 
        var status = e.target.checked === true ? '1' : '0';
        axios.put(`api/users/updateStatus?id=${id}`, {status}).then(res => {                
        })
        .catch(err => {
        })
    }
    const handleUserLogin = (email) => {
        // Send a POST request to your API endpoint with the email as data
        axios.post('/api/auth/another/login', { email: email })
          .then((res) => {
            if (res.data.success) {
              localStorage.clear();
              localStorage.setItem('FF-authUser', JSON.stringify(res.data.data));
              navigate('/organizations');
            } else {
              Swal.fire(res.data.message, '', 'info');
            }
          })
          .catch((error) => {
            Swal.fire(error.message, '', 'info');
          });
    };

    const columns = [
        {
            name: 'Admin Name',
            selector: row => row.name,
            sortable: true,
            width: '18%'
        },
        {
            name: 'Company Name',
            selector: row => row.organizationName,
            sortable: true,
            width: '18%'
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            width: '22%'
        },
        {
            name: 'Phone',
            selector: row => row.phone,
            sortable: true,
            width: '10%'
        },
        {
            name: 'Status',
            cell: row => (
               <Switch className="Rj-toggle" {...label} defaultChecked={row.status === '1' ? true : false} color="info" onChange={(e) => handleStatus(e, row.id)}/>                
            )
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <Tooltip onClick={(e) =>  {handleEdit(row.id)}} data-bs-toggle="modal" data-bs-target="#addUserModal" title="Edit" size='small' className='icon icon-sm icon-secondary'>
                        <IconButton>
                             <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick={() => handleDelete(row.id)} title="Delete" size='small' className='icon icon-sm icon-primary ms-2'>
                        <IconButton>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </>
                
            )
        },
         {
            name: 'login',
           cell: row => (
                <Link onClick={(e) =>  {handleUserLogin(row.email)}} className="clr-theme"><LoginIcon/> </Link>            
            )
        },
    ];
    return(
        <Layout>
            <Header pageTitle="Users" />
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h3 className="fw-bold mb-0">Admins</h3>
                        <div>
                            <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal" data-bs-target="#uploadExcelModal" onClick={handleUpload}>
                                <span className="tf-icons bx bx-upload"></span>&nbsp; Upload Excel
                            </button>
                            <button type="button" className="btn btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#addUserModal" onClick={handleAdd}>
                                <span className="tf-icons bx bx-plus"></span>&nbsp; Add Admin
                            </button>
                        </div>
                    </div>
                    <div className="table text-nowrap">
                        <div className="">
                            <DataTableComp columns={columns} data={users} isIndex={true} />                            
                        </div>
                    </div>
                </div>
            </div>
            <AddUser type={popupType} getList={getList} editId={editId} setEditId={setEditId} show={show} setShow={setShow}/>
            
            <UploadExcel show={showexcelform} setShow={setShowexcelform} handleClose={handleCloseExcel} getList={getList}/>
        </Layout>
    )
}